<template>
  <v-card class="show experience" v-if="experience">
    <v-card-title primary-title>
      <LogoUpload
        v-if="experience.organization.id"
        :src="experience.organization.logo ? experience.organization.logo : '/img/missing/logos/organizations/original.png'"
        :path="`/admin/experience_organizations/${experience.organization.id}/logo`"
        @success="logoSuccess"
      />
      <v-avatar v-else class="mr-3">
        <v-img :src="experience.organization.logo ? experience.organization.logo : '/img/missing/logos/organizations/original.png'" />
      </v-avatar>
      <div>
        <div class="headline">{{ experience.position }}</div>
        <span class="subheading grey--text">{{ experience.organization.name }}</span>
      </div>
    </v-card-title>

    <!-- Attributes table -->
    <v-divider />
    <table class="v-table theme--dark">
      <tbody>
        <tr>
          <th class="text-xs-right">ID</th>
          <td>{{ experience.id }}</td>
        </tr>
        <tr>
          <th class="text-xs-right">Profile</th>
          <td>
            <router-link :to="`/profiles/${experience.profile.id}`">
              {{ experience.profile.name }}
            </router-link>
          </td>
        </tr>
        <tr>
          <th class="text-xs-right">Position</th>
          <td>{{ experience.position }}</td>
        </tr>
        <tr>
          <th class="text-xs-right">Type</th>
          <td>{{ experience.type }}</td>
        </tr>
        <tr>
          <th class="text-xs-right">Organization</th>
          <td>{{ experience.organization.name }}</td>
        </tr>
        <tr>
          <th class="text-xs-right">Industry</th>
          <td v-if="experience.organization.industry">{{ experience.organization.industry }}</td>
          <td v-else><em>Not specified</em></td>
        </tr>
        <tr>
          <th class="text-xs-right">From</th>
          <td>{{ new Date(experience.startsAt) | date("do MMMM yyyy") }}</td>
        </tr>
        <tr>
          <th class="text-xs-right">until</th>
          <td v-if="experience.endsAt">{{ new Date(experience.endsAt) | date("do MMMM yyyy") }}</td>
          <td v-else><em>present</em></td>
        </tr>
        <tr>
          <th class="text-xs-right">Disciplines</th>
          <td v-if="experience.disciplines && experience.disciplines.length">
            <v-chip v-for="discipline in experience.disciplines"
              :key="`discipline-${discipline.id}`">
              {{ discipline.name }}
            </v-chip>
          </td>
          <td v-else><em>None specified</em></td>
        </tr>
        <tr>
          <th class="text-xs-right">Last updated</th>
          <td>
            {{ new Date(experience.updatedAt) | date("h:mm a, MMMM do yyyy") }}
            ({{ new Date(experience.updatedAt) | inWords({ addSuffix: true }) }})
          </td>
        </tr>
        <tr>
          <th class="text-xs-right">Created</th>
          <td>
            {{ new Date(experience.createdAt) | date("h:mm a, MMMM do yyyy") }}
            ({{ new Date(experience.createdAt) | inWords({ addSuffix: true }) }})
          </td>
        </tr>

        <tr v-if="experience.responsibilities && experience.responsibilities.length">
          <td colspan="2">
            <label class="d-block my-2"><strong>Responsibilities</strong></label>
            <ul class="my-4">
              <li
                v-for="responsibility in experience.responsibilities"
                :key="responsibility" v-text="responsibility"
              />
            </ul>
          </td>
        </tr>
        <tr v-else>
          <th class="text-xs-right">Responsibilities</th>
          <td><em>None specified</em></td>
        </tr>
      </tbody>
    </table>
    <v-divider />

    <v-card-actions><v-spacer />
      <can I="delete" a="Experience">
        <v-dialog v-model="dialog" lazy absolute max-width="600">
          <v-btn flat color="error" slot="activator">Delete</v-btn>

          <v-card>
            <v-card-title>
              <div class="headline">Are you sure?</div>
            </v-card-title>
            <v-card-text>
              <p>
                This action cannot be undone and will remove this work
                experience from the user's profile.
              </p>
            </v-card-text>
            <v-card-actions><v-spacer />
              <v-btn color="grey" flat @click="dialog = false">cancel</v-btn>
            <v-btn color="error" @click="destroy">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </can>
      <can I="edit" a="Experience">
        <v-btn color="primary" @click="$emit('edit')">
          <v-icon left>mdi-pencil</v-icon> Edit
        </v-btn>
      </can>
    </v-card-actions>
  </v-card>
</template>

<script>
// Components
import LogoUpload from '@/components/LogoUpload'

export default {
  components: { LogoUpload },

  props: {
    experience: Object,
  },

  data() {
    return {
      dialog: false,
    }
  },

  methods: {
    logoSuccess() {
      this.$store.commit('snackbar', {
        text: 'Logo uploaded!',
        type: 'success',
      })
      this.$emit('refresh')
    },
    destroy() { this.$emit('destroy') },
  }
}
</script>
